import { Link } from "gatsby"
import React from "react"

const CategoryPill = ({ name, uri, className, ...props }) => {
  return (
    <Link
      className={`mx-2 py-2 px-3 rounded-xl flex-shrink-0 text-white transition hover:-translate-y-px text-base bg-[#360B3B90] dark:bg-secondary ${className}`}
      to={uri}
      {...props}
    >
      {name}
    </Link>
  )
}

export default CategoryPill
